var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('legend', [_vm._v("Create Connection Schedule/LHCO")]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('RouteType')
    },
    attrs: {
      "options": _vm.routetypelist,
      "isDisabled": (_vm.istripFound || _vm.tripCreated) && _vm.showshedule,
      "selected-option": _vm.routetypeitem,
      "name": "RouteType",
      "placeholder": "Select Route Type"
    },
    on: {
      "select": _vm.selectRouteType
    },
    model: {
      value: (_vm.routetype),
      callback: function($$v) {
        _vm.routetype = $$v
      },
      expression: "routetype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RouteType')),
      expression: "errors.has('RouteType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('RouteType')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Name:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ConnectionID')
    },
    attrs: {
      "options": _vm.listConnectionNameData,
      "selected-option": _vm.listConnectionNameDataObj,
      "isDisabled": (_vm.istripFound || _vm.tripCreated) && _vm.showshedule,
      "name": "ConnectionID",
      "placeholder": "Select Connection"
    },
    on: {
      "select": _vm.selectedHubConnection
    },
    model: {
      value: (_vm.ConnectionID),
      callback: function($$v) {
        _vm.ConnectionID = $$v
      },
      expression: "ConnectionID"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.connectionLoading))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ConnectionID')),
      expression: "errors.has('ConnectionID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Connection Name field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Route Mode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routemode),
      expression: "routemode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('RouteMode')
    },
    attrs: {
      "name": "RouteMode",
      "id": "routemode",
      "disabled": ((_vm.istripFound || _vm.tripCreated) && _vm.showshedule) || _vm.routetype == 1 || _vm.routetype == 5
    },
    on: {
      "click": _vm.selctedRouteMode,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.routemode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": "null"
    }
  }, [_vm._v("Select Route Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Surface"
    }
  }, [_vm._v("Surface")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Train"
    }
  }, [_vm._v("Train")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('RouteMode')),
      expression: "errors.has('RouteMode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('RouteMode')))])], 1)])]), _vm._v(" "), (_vm.ConnectionID) ? _c('div') : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "userfooter"
  }, [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadpendingbags()
      }
    }
  }, [_vm._v("Load Bags")]), _vm._v(" \n                "), _c('b-button', {
    staticClass: "-common-secondary",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button",
      "disabled": (_vm.istripFound || _vm.tripCreated) && _vm.showshedule
    },
    on: {
      "click": function($event) {
        return _vm.createchedule()
      }
    }
  }, [_vm._v("Create/Show Schedule For Outscan")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetFormFinal
    }
  }, [_vm._v(" Reset")])], 1), _vm._v(" "), _c('b-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showshedule || _vm.showTripForm || _vm.istripFound),
      expression: "showshedule || showTripForm || istripFound"
    }],
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showshedule) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', {
    staticClass: "legendtype"
  }, [_vm._v("Schedule Details")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    }
  }, [_c('thead', {
    staticClass: "head"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CSMID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("RouteMode ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("InvoiceNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Allowed Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CreatedDate")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scheduledata.connectionschedulemaster))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scheduledata.routemode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scheduledata.invoiceno))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.scheduledata.allowroutemode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.scheduledata.createddate)))])])])]), _vm._v(" "), (_vm.routetype == 3) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "userfooter",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.allowotherbag()
      }
    }
  }, [_vm._v("Allow Other Bag")]), _vm._v(" \n                      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showTripForm) ? _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.disableStartTrip
    },
    on: {
      "update:active": function($event) {
        _vm.disableStartTrip = $event
      }
    }
  }), _vm._v(" "), _c('legend', {
    staticClass: "legendtype"
  }, [_vm._v("Vehicle Details ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Trip Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.triptype),
      expression: "triptype"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isTripStartedFirst || _vm.routetype == 5,
      "name": "triptype",
      "id": "triptype"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.triptype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getvehiclelist()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": "null"
    }
  }, [_vm._v("Select trip type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vendorbased",
      "disabled": _vm.routetype == 5
    }
  }, [_vm._v("Vendor Based")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "markethired",
      "disabled": _vm.routetype == 5
    }
  }, [_vm._v("Market Hired")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "coloader",
      "disabled": _vm.routetype !== 3
    }
  }, [_vm._v("Coloader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "brookandbond",
      "disabled": _vm.routetype !== 5
    }
  }, [_vm._v("BrooksNBonds")])])]), _vm._v(" "), (_vm.triptypeerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Trip Type field is required.")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.triptype == 'brookandbond') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Type:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true, 'error': _vm.errors.has('vehicletype')
    },
    attrs: {
      "isDisabled": _vm.isTripStartedFirst,
      "options": _vm.vehicleType,
      "selected-option": _vm.selectedvehicleType,
      "name": "vehicletype",
      "placeholder": "Select vehicle type"
    },
    on: {
      "select": _vm.selectedvehicletype
    }
  })], 1), _vm._v(" "), (_vm.vehicletypeerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("The Vehicle type field is required.")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.triptype !== 'coloader' && _vm.triptype !== 'brookandbond' && _vm.triptype !== 'markethired') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Vehicle:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true, 'error': _vm.errors.has('vehicle')
    },
    attrs: {
      "isDisabled": _vm.isTripStartedFirst,
      "options": _vm.listVehicleData,
      "selected-option": _vm.listlistVehicleDataObj,
      "name": "vehicle",
      "placeholder": "Select vehicle"
    },
    on: {
      "select": _vm.selectedvehicle
    }
  })], 1), _vm._v(" "), (_vm.vehiclenoerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("The Vehicle No field is required.")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.triptype == 'coloader' || _vm.triptype == 'brookandbond' || _vm.triptype == 'markethired') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Enter VehicleNo:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VehicleNo),
      expression: "VehicleNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.isTripStartedFirst,
      "placeholder": "Enter VehicleNo",
      "name": "VehicleNo",
      "id": "VehicleNo",
      "title": "Use Space As Delimiter e.g. MH 01 AB 0123, DL 01L AB 1234, PB 01 1212, MHU 123, DL 1 GE 2236, DL 1L AH 4206, TN 52 Y 5027, AB 123 A 1234, AB 12 ABC 1234",
      "pattern": "^([A-Z|a-z]{2}\\s{1}[0-9]{1,2}\\s{1}[A-Z|a-z]{1,3}\\s{1}\\d{4})?([A-Z|a-z]{2}\\s{1}[0-9]{1,2}[A-Z|a-z]{1}\\s{1}[A-Z|a-z]{2}\\s{1}\\d{4})?([A-Z|a-z]{3}\\s{1}\\d{3})?([A-Z|a-z]{2}\\s{1}[0-9]{2}\\s{1}\\d{4})?([A-Z|a-z]{2}\\s{1}[0-9]{1,3}\\s{1}[A-Z|a-z]{1}\\s{1}\\d{3,4})?$"
    },
    domProps: {
      "value": (_vm.VehicleNo)
    },
    on: {
      "change": _vm.checkvehicleno,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.VehicleNo = $event.target.value
      }, function($event) {
        _vm.VehicleNo = _vm.VehicleNo.toUpperCase()
      }]
    }
  })]), _vm._v(" "), (_vm.vehiclenoerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("The Vehicle No field is required.")]) : _vm._e(), _vm._v(" "), (_vm.validVehicleNoError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Invalid VehicleNo, Use Space As Delimiter e.g.MH 01 AB 0123, DL 01L AB 1234, PB 01 1212, MHU 123, TN 52 Y 5027, AB 123 A 1234, AB 12 ABC 1234")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Enter OpenKm:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('checkopenkm'),
      expression: "'checkopenkm'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.OpenKm),
      expression: "OpenKm"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('RouteMode')
    },
    attrs: {
      "type": "number",
      "disabled": _vm.isTripStartedFirst,
      "maxlength": "9",
      "placeholder": "Enter OpenKm",
      "name": "OpenKm",
      "id": "OpenKm"
    },
    domProps: {
      "value": (_vm.OpenKm)
    },
    on: {
      "change": _vm.checkopenkm,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.OpenKm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('OpenKm')),
      expression: "errors.has('OpenKm')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('OpenKm')))]), _vm._v(" "), (_vm.openkmerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("The OpenKm field is required.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Cut Off:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-clock-o'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true, 'error': _vm.errors.has('Cutoff')
    },
    attrs: {
      "isDisabled": _vm.isTripStartedFirst,
      "options": _vm.cutofflist,
      "selected-option": _vm.cutoffitem,
      "name": "Cutoff",
      "placeholder": "Select Cutoff"
    },
    on: {
      "select": _vm.selectedCutoff
    },
    model: {
      value: (_vm.cutoff),
      callback: function($$v) {
        _vm.cutoff = $$v
      },
      expression: "cutoff"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.CutoffError))]), _vm._v(" "), (_vm.isCutoffError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("The Cut Off field is required.")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "userfooter"
  }, [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isTripStartedFirst
    },
    on: {
      "click": function($event) {
        return _vm.createTrip()
      }
    }
  }, [_vm._v("Start Trip")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.isTripStartedFirst
    },
    on: {
      "click": _vm.resetVehicleForm
    }
  }, [_vm._v(" Reset")])])], 1) : _vm._e(), _vm._v(" "), (_vm.istripFound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "legendtype"
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "margin-top": "-10px"
    }
  }, [_c('thead', {
    staticClass: "head"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("TripNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trip Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("VehicleNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Open km")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.tripno))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.triptype))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.vehicleno))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.vendorname))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.tripdata.openkm))])])])])]), _vm._v(" "), (_vm.routetype == 3) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "userfooter",
    staticStyle: {
      "margin-top": "7px"
    }
  }, [_c('button', {
    staticClass: "common-secondary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.allowreplace()
      }
    }
  }, [_vm._v("Replace Vehicle")]), _vm._v(" \n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.allowreplacevehicle) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Enter VehicleNo:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replacedvehicleno),
      expression: "replacedvehicleno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter VehicleNo",
      "name": "replacedvehicleno",
      "id": "replacedvehicleno",
      "title": "Use Space As Delimiter e.g. MH 01 AB 0123, DL 01L AB 1234, PB 01 1212, MHU 123, DL 1 GE 2236, DL 1L AH 4206, TN 52 Y 5027, AB 123 A 1234, AB 12 ABC 1234",
      "pattern": "^([A-Z|a-z]{2}\\s{1}[0-9]{1,2}\\s{1}[A-Z|a-z]{1,3}\\s{1}\\d{4})?([A-Z|a-z]{2}\\s{1}[0-9]{1,2}[A-Z|a-z]{1}\\s{1}[A-Z|a-z]{2}\\s{1}\\d{4})?([A-Z|a-z]{3}\\s{1}\\d{3})?([A-Z|a-z]{2}\\s{1}[0-9]{2}\\s{1}\\d{4})?([A-Z|a-z]{2}\\s{1}[0-9]{1,3}\\s{1}[A-Z|a-z]{1}\\s{1}\\d{3,4})?$"
    },
    domProps: {
      "value": (_vm.replacedvehicleno)
    },
    on: {
      "change": _vm.replacedvehiclenocheckfunction,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.replacedvehicleno = $event.target.value
      }, function($event) {
        _vm.replacedvehicleno = _vm.replacedvehicleno.toUpperCase()
      }]
    }
  })]), _vm._v(" "), (_vm.replacedvehiclenoerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("The replace vehicle no. field is required.")]) : _vm._e(), _vm._v(" "), (_vm.validreplacedvehiclenoerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Invalid VehicleNo, Use Space As Delimiter e.g.MH 01 AB 0123, DL 01L AB 1234, PB 01 1212, MHU 123, DL 1 GE 2236, DL 1L AH 4206, TN 52 Y 5027, AB 123 A 1234, AB 12 ABC 1234")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "userfooter",
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.replecevehicle()
      }
    }
  }, [_vm._v("Replace")]), _vm._v(" \n                              "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetreplacevehicle()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" \n                            ")])])])]) : _vm._e()]) : _vm._e()])])])], 1)]), _vm._v(" "), (_vm.dockLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": true,
      "is-full-screen": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isDockMandatory && !_vm.dockLoading) ? _c('fieldset', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Dock ID:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.dockList,
      "selected-option": _vm.selectedDock,
      "isDisabled": !((_vm.istripFound || _vm.tripCreated) && _vm.showshedule) || _vm.isDockDropdownDisabled,
      "name": "DockId",
      "placeholder": "Select Dock"
    },
    on: {
      "select": _vm.selectDock
    },
    model: {
      value: (_vm.dockId),
      callback: function($$v) {
        _vm.dockId = $$v
      },
      expression: "dockId"
    }
  })], 1), _vm._v(" "), (_vm.dockIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Dock ID is required.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Dock Barcode:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scannedDockBarcode),
      expression: "scannedDockBarcode"
    }],
    ref: "scanDockInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "scannedDockBarcode",
      "id": "scannedDockBarcode",
      "placeholder": "Scan / enter dock barcode",
      "autocomplete": "off",
      "disabled": !((_vm.istripFound || _vm.tripCreated) && _vm.showshedule) || _vm.isScanDockBarcodeDisabled
    },
    domProps: {
      "value": (_vm.scannedDockBarcode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onDockBarcodeScan.apply(null, arguments)
      },
      "change": _vm.onDockBarcodeScan,
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scannedDockBarcode = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "common-success-btn",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "button",
      "disabled": !((_vm.istripFound || _vm.tripCreated) && _vm.showshedule) || !_vm.dockbarcode || _vm.isDockIn
    },
    on: {
      "click": function($event) {
        return _vm.dockIn()
      }
    }
  }, [_vm._v("Dock In")]), _vm._v("  \n\n                    "), _vm._v(" "), _c('b-button', {
    staticClass: "common-secondary-btn",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isDockIn
    },
    on: {
      "click": function($event) {
        return _vm.openChangeDockModal()
      }
    }
  }, [_vm._v("Change Dock")])], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.schedulebag.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag No.:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNumber),
      expression: "bagNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter bag no",
      "name": "bagNumber",
      "id": "bagNumber",
      "disabled": !((_vm.istripFound || _vm.tripCreated) && _vm.showshedule && (_vm.isDockMandatory ? _vm.isDockIn : true)),
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.bagNumber)
    },
    on: {
      "keyup": [function($event) {
        return _vm.checkShipmentInput($event)
      }, _vm.clearError],
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagNoError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "submit",
      "disabled": !((_vm.istripFound || _vm.tripCreated) && _vm.showshedule)
    }
  }, [_vm._v("Scan Out")]), _vm._v("  \n                      "), _c('button', {
    staticClass: "common-danger",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.cancelID
    }
  }, [_vm._v("Cancel")]), _vm._v("  \n                      "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrealert),
      expression: "showPrealert"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("Send prealert")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em",
      "padding-top": "36px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ConfirmConnection),
      expression: "ConfirmConnection"
    }],
    attrs: {
      "type": "checkbox",
      "id": "ConfirmConnection",
      "value": "ConfirmConnection",
      "disabled": !((_vm.istripFound || _vm.tripCreated) && _vm.showshedule && _vm.scheduledBagsListData.length > 0)
    },
    domProps: {
      "checked": Array.isArray(_vm.ConfirmConnection) ? _vm._i(_vm.ConfirmConnection, "ConfirmConnection") > -1 : (_vm.ConfirmConnection)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.ConfirmConnection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "ConfirmConnection",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ConfirmConnection = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ConfirmConnection = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ConfirmConnection = $$c
        }
      }, function($event) {
        return _vm.getlhcosuggestion()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "ConfirmConnection"
    }
  }, [_vm._v("Confirm Connection")])])], 1)])]), _vm._v(" "), (_vm.ConfirmConnection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('legend', {
    staticClass: "legendtype"
  }, [_vm._v("Confirm Connection")]), _vm._v(" "), (_vm.routetype == 3) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Suggested Coloaders")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("T/F#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("T/F Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ColoaderID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Coloader Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Departure Date & Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Arrival Date And Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CTD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Transit Hrs")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Today Availability")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.suggessionData), function(data, index) {
    return _c('tr', {
      key: index,
      class: [_vm.selectedColoader.includes(data.LineHaulRateID) == true ? 'selected-color' : '' ]
    }, [_c('td', [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "",
        "disabled": _vm.selectedColoader.includes(data.LineHaulRateID)
      },
      domProps: {
        "checked": _vm.selectedColoader.includes(data.LineHaulRateID)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelectColader(data)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr"
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TFNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TFName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ColoaderID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ColoaderName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.NextPossibleDepartureDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.NextPossibleArrivalDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CTD))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TotalTransitTime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.IsTodayAvailable == true) ? _c('span', {
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v("Yes")]) : _vm._e(), (data.IsTodayAvailable == false) ? _c('span', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("No")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.selectedColoader.includes(data.LineHaulRateID)) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_vm._v("Reject Reason:")]), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-archive'></i>"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.rejectreason),
        expression: "rejectreason"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.isDisableRejectColoader,
        "name": "rejectreason",
        "id": "rejectreason"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.rejectreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          return _vm.checkrejectreason()
        }]
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": "",
        "value": "null"
      }
    }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Weight issue with co-loader"
      }
    }, [_vm._v("Weight issue with co-loader")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Non-Upliftment"
      }
    }, [_vm._v("Non-Upliftment")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Breakdown/Accident"
      }
    }, [_vm._v("Breakdown/Accident")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Security offloaded bags"
      }
    }, [_vm._v("Security offloaded bags")])])]), _vm._v(" "), (_vm.rejectreasonerror) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Please select reject reason")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "margin-top": "25px"
      }
    }, [_c('b-button', {
      staticClass: "common-success",
      attrs: {
        "disabled": _vm.isDisableRejectColoader
      },
      on: {
        "click": function($event) {
          return _vm.rejectcoloader(data, index)
        }
      }
    }, [_vm._v("Reject")])], 1)]) : _vm._e()])])
  }), 0)]), _vm._v(" "), (_vm.coloaderselecterror == true) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please select coloader")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.routetype == 3) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline",
      "margin-top": "15px"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeConnectionRouteModeFunction()
      }
    }
  }, [_vm._v("Change Connection Route Mode")]), _vm._v(" \n                  ")]), _vm._v(" "), (_vm.routetype == 3) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "-25px",
      "text-align": "right"
    }
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.ConfirmConnectionSave
    }
  }, [_vm._v("Confirm Connection")]), _vm._v("  \n                      ")])], 1)], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.routetype == 1 || _vm.routetype == 5) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": _vm.ConfirmConnectionSave
    }
  }, [_vm._v("Confirm Connection")]), _vm._v("  \n                  ")])], 1)], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showpendingbags || _vm.showshedule),
      expression: "showpendingbags || showshedule"
    }],
    staticStyle: {
      "border": "1px solid #cecece"
    },
    attrs: {
      "content-class": "mt-3"
    }
  }, [(_vm.showpendingbags) ? _c('b-tab', {
    attrs: {
      "title": 'Pending Schedule Bags' + '(' + _vm.pendingBagsListData.length + ')',
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.loadpendingbags()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.loadpendingbags()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload pending bag list"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("createddate")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingBagsListData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.physicalweight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.volumetricweight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.chargeableweight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), (_vm.pendingBagsListData.length == 0 || _vm.pendingBagsListData.length === undefined) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.showshedule) ? _c('b-tab', {
    attrs: {
      "title": 'Scheduled Bags' + '(' + _vm.scheduledBagsListData.length + ')'
    },
    on: {
      "click": function($event) {
        return _vm.loadsheduledbags()
      }
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.loadsheduledbags()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this inscan list"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("createddate")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.scheduledBagsListData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.physicalweight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.volumetricweight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.chargeableweight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-primary",
      on: {
        "click": function($event) {
          return _vm.removeBagFromSchedule(data)
        }
      }
    }, [_vm._v("Remove")])])])
  }), _vm._v(" "), (_vm.scheduledBagsListData.length == 0 || _vm.scheduledBagsListData.length === undefined) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])]) : _vm._e()], 1)], 1)])])], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.allowotherbagmodel = false
      }
    },
    model: {
      value: (_vm.allowotherbagmodel),
      callback: function($$v) {
        _vm.allowotherbagmodel = $$v
      },
      expression: "allowotherbagmodel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Allow Bags")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeallowotherbagmodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allowbagmode),
      expression: "allowbagmode"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "allowbagmode",
      "id": "allowbagmode"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.allowbagmode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.checkmode()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Mode")]), _vm._v(" "), (_vm.routemode == 'Air' || _vm.routemode == 'Train') ? _c('option', {
    attrs: {
      "value": "Surface"
    }
  }, [_vm._v("Surface")]) : _vm._e(), _vm._v(" "), (_vm.routemode == 'Surface' || _vm.routemode == 'Train') ? _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")]) : _vm._e(), _vm._v(" "), (_vm.routemode == 'Air' || _vm.routemode == 'Surface') ? _c('option', {
    attrs: {
      "value": "Train"
    }
  }, [_vm._v("Train")]) : _vm._e()])]), _vm._v(" "), (_vm.allowbagmodeerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Mode field is required.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reason:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allowbagreason),
      expression: "allowbagreason"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "allowbagreason",
      "id": "allowbagreason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.allowbagreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.checkreason()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "space constraint"
    }
  }, [_vm._v("Space constraint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "contains dangerous goods"
    }
  }, [_vm._v("contains dangerous goods")])])]), _vm._v(" "), (_vm.allowbagreasonerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reason field is required.")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.allowotherbagsave
    }
  }, [_vm._v("Allow Bag")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeallowotherbagmodel
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.ChangeConnectionRouteModemodel = false
      }
    },
    model: {
      value: (_vm.ChangeConnectionRouteModemodel),
      callback: function($$v) {
        _vm.ChangeConnectionRouteModemodel = $$v
      },
      expression: "ChangeConnectionRouteModemodel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Change Connection Route Mode")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeChangeConnectionRouteModemodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Mode:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ChangeConnectionRouteMode),
      expression: "ChangeConnectionRouteMode"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ChangeConnectionRouteMode",
      "id": "ChangeConnectionRouteMode"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ChangeConnectionRouteMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.checkChangeConnectionRouteMode()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Mode")]), _vm._v(" "), (_vm.routemode == 'Air' || _vm.routemode == 'Train') ? _c('option', {
    attrs: {
      "value": "Surface"
    }
  }, [_vm._v("Surface")]) : _vm._e(), _vm._v(" "), (_vm.routemode == 'Surface' || _vm.routemode == 'Train') ? _c('option', {
    attrs: {
      "value": "Air"
    }
  }, [_vm._v("Air")]) : _vm._e(), _vm._v(" "), (_vm.routemode == 'Air' || _vm.routemode == 'Surface') ? _c('option', {
    attrs: {
      "value": "Train"
    }
  }, [_vm._v("Train")]) : _vm._e()])]), _vm._v(" "), (_vm.ChangeConnectionRouteModeerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Mode field is required.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Change Reason:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ChangeConnectionRouteModereason),
      expression: "ChangeConnectionRouteModereason"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ChangeConnectionRouteModereason",
      "id": "ChangeConnectionRouteModereason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ChangeConnectionRouteModereason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.checkChangeConnectionRouteModereason()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Strike"
    }
  }, [_vm._v("Strike")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Natural calamity"
    }
  }, [_vm._v("Natural calamity")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Political disturbance"
    }
  }, [_vm._v("Political disturbance")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Local holidays"
    }
  }, [_vm._v("Local holidays")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Operational issue"
    }
  }, [_vm._v("Operational issue")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Embargo declared"
    }
  }, [_vm._v("Embargo declared")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Co-loader reject"
    }
  }, [_vm._v("Co-loader reject")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DG item not worthy to travel by air"
    }
  }, [_vm._v("DG item not worthy to travel by air")])])]), _vm._v(" "), (_vm.ChangeConnectionRouteModereasonerror) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reason field is required.")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "-common-success-btnn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ChangeConnectionRouteModesave
    }
  }, [_vm._v("Update Connection Route")]), _vm._v(" "), _c('button', {
    staticClass: "-common-success-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.CancelCurrentSchedule
    }
  }, [_vm._v("Cancel Current Schedule")]), _vm._v(" "), _c('button', {
    staticClass: "common-btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeChangeConnectionRouteModemodel
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.showMultipartShipmentModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.showMultipartShipmentModal),
      callback: function($$v) {
        _vm.showMultipartShipmentModal = $$v
      },
      expression: "showMultipartShipmentModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Shipment List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Multi Shipment Group Id")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.multipartShipmentData), function(data, index) {
    return (_vm.multipartShipmentData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MultiShipmentGroupId))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.clientrefData), function(data, index) {
    return (_vm.clientrefData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.multishipmentgroupid))])]) : _vm._e()
  })], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showMultipartDataForConfirmConn == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.showMultipartDataForConfirmConn),
      callback: function($$v) {
        _vm.showMultipartDataForConfirmConn = $$v
      },
      expression: "showMultipartDataForConfirmConn"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Bag List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModalForConConn
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bagstatus Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Multi Shipment Group Id")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipartDataForConfirmConn), function(data, index) {
    return (_vm.multipartDataForConfirmConn.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.multishipmentgroupid))])]) : _vm._e()
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showemailpage),
      expression: "showemailpage"
    }],
    ref: "showemailpage",
    attrs: {
      "size": "lg",
      "title": "Send Mail"
    },
    on: {
      "click": _vm.closeSendMailPage
    },
    model: {
      value: (_vm.showemailpage),
      callback: function($$v) {
        _vm.showemailpage = $$v
      },
      expression: "showemailpage"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Send Mail")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSendMailPage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mail ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailId),
      expression: "mailId"
    }],
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "name": "mailId",
      "id": "mailId",
      "rows": "2",
      "cols": "50",
      "placeholder": "Enter MailId, Use Comma For Multiple MailId's"
    },
    domProps: {
      "value": (_vm.mailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.emailIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.emailIdValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdValidationMSG))]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.SendMailFunction
    }
  }, [_vm._v("Send Mail")]), _vm._v("  \n        "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormForMail
    }
  }, [_vm._v("Reset Mail")])])], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Change Dock"
    },
    on: {
      "show": _vm.resetChangeDockForm
    },
    model: {
      value: (_vm.showChangeDockModal),
      callback: function($$v) {
        _vm.showChangeDockModal = $$v
      },
      expression: "showChangeDockModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Change Dock")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeChangeDockModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("New Dock ID:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.dockList,
      "selected-option": _vm.newDockSelected,
      "name": "NewDockId",
      "placeholder": "Select Dock",
      "isDisabled": _vm.isNewDockDropdownDisabled
    },
    on: {
      "select": _vm.selectNewDock
    },
    model: {
      value: (_vm.newDockId),
      callback: function($$v) {
        _vm.newDockId = $$v
      },
      expression: "newDockId"
    }
  })], 1), _vm._v(" "), (_vm.newDockIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please select or scan a new dock.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan New Dock Barcode:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newScannedDockBarcode),
      expression: "newScannedDockBarcode"
    }],
    ref: "scanNewDockInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "newScannedDockBarcode",
      "id": "newScannedDockBarcode",
      "placeholder": "Scan / enter dock barcode",
      "autocomplete": "off",
      "disabled": _vm.isNewScanDockBarcodeDisabled
    },
    domProps: {
      "value": (_vm.newScannedDockBarcode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onNewDockBarcodeScan.apply(null, arguments)
      },
      "change": _vm.onNewDockBarcodeScan,
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newScannedDockBarcode = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reason:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.getDockChangeReasonList,
      "name": "selectedDockChangeReason",
      "selected-option": _vm.selectedDockChangeReason,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectReasonForNewDock
    }
  })], 1), _vm._v(" "), (_vm.selectedReasonError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reason is required.")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveDockChange
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeChangeDockModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f33341","hasScoped":true}!./src/views/components/CenterScanOut/Centerscanout.component.html
// module id = 976
// module chunks = 2